import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import Invoices from "@/pages/Invoices";
import Quotations from "@/pages/Quotations";
import Payments from "@/pages/Payments";

export default function Sales() {
  return (
    <Tabs defaultValue="invoices">
      <div className="mb-2">
        <h1 className="font-heading text-3xl font-bold tracking-tight">Sales</h1>
        <p className="text-sm text-muted-foreground mt-1">Invoices, quotations and receipts</p>
      </div>
      <TabsList>
        <TabsTrigger value="invoices" data-testid="tab-sales-invoices">Invoices</TabsTrigger>
        <TabsTrigger value="quotations" data-testid="tab-sales-quotations">Quotations</TabsTrigger>
        <TabsTrigger value="payments" data-testid="tab-sales-payments">Payments In</TabsTrigger>
      </TabsList>
      <TabsContent value="invoices" className="mt-4"><Invoices /></TabsContent>
      <TabsContent value="quotations" className="mt-4"><Quotations /></TabsContent>
      <TabsContent value="payments" className="mt-4"><Payments /></TabsContent>
    </Tabs>
  );
}
